import { Injectable, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import type {
    BankAccountStripeOnboardingDialogInput,
    BankAccountStripeOnboardingDialogResult,
} from '../../components/app-layout/shared/bank-account-stripe-onboarding-dialog/bank-account-stripe-onboarding-dialog.component';

/**
 * Opens Stripe's embedded onboarding for `FinancialConnectionsService`, which has no template of
 * its own. `app-bank-account-flow-dialogs-host` at the app root renders the dialog while `open`.
 */
@Injectable({ providedIn: 'root' })
export class BankAccountStripeOnboardingDialogStateService {
    readonly open = signal(false);
    readonly data = signal<BankAccountStripeOnboardingDialogInput>({ organizationId: null });

    private _result$: Subject<BankAccountStripeOnboardingDialogResult | null> | null = null;

    constructor(location: Location) {
        // Browser back/forward cancels, as MatDialog's closeOnNavigation did.
        location.subscribe(() => this.answer(null));
    }

    ask(data: BankAccountStripeOnboardingDialogInput): Observable<BankAccountStripeOnboardingDialogResult | null> {
        this.answer(null);
        this._result$ = new Subject<BankAccountStripeOnboardingDialogResult | null>();
        this.data.set(data);
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: BankAccountStripeOnboardingDialogResult | null): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
